import React, { useEffect, useState } from 'react';
import { Autocomplete, TextField, CircularProgress } from '@mui/material';
import { validLocationService } from '../../service/validLocationService';
import { toast } from 'react-toastify';

function CitySelect({ field, form, countryId, label, size }) {
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!countryId) return;

    const fetchCities = async () => {
      setLoading(true);
      try {
        const response = await validLocationService.getCities(countryId);
        const {code, message, data} = response;

        if (code === 0 ) {
          setCities(data.data);
        } else {
          toast.info(message)
        }
        
      } catch (error) {
        console.error("Error fetching valid cities:", error);
      }
      setLoading(false);
    };

    fetchCities();
  }, [countryId]);

  /*
  The isOptionEqualToValue prop in Material-UI's Autocomplete component is used to determine 
  whether two values are equal. This is necessary because the value prop might be an object, 
  and we need to specify how to compare it to the option objects.
  */
  return (
    <Autocomplete
      freeSolo
      options={cities}
      getOptionLabel={(option) => typeof option === 'string' ? option : option.name}
      isOptionEqualToValue={(option, value) => (
        option.name === (typeof value === 'string' ? value : value.name)
      )}
      value={cities.find((option) => option.name === field.value) || null}
      inputValue={field.value || ''}
      onInputChange={(event, newInputValue, reason) => {
        if (reason === 'input' || reason === 'clear') {
          form.setFieldValue(field.name, newInputValue);
        }
      }}
      onChange={(event, newValue) => {
        const cityName = typeof newValue === 'string' ? newValue : newValue?.name || '';
        form.setFieldValue(field.name, cityName);
      }}
      onBlur={() => form.setFieldTouched(field.name, true)}
      loading={loading}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          variant="outlined"
          size={size || "small"}
          error={Boolean(form.errors[field.name] && form.touched[field.name])}
          helperText={form.errors[field.name] && form.touched[field.name] ? form.errors[field.name] : ""}
          InputProps={{
        ...params.InputProps,
        endAdornment: (
          <>
            {loading ? <CircularProgress color="inherit" size={20} /> : null}
            {params.InputProps.endAdornment}
          </>
        ),
          }}
        />
      )}
      filterOptions={(options, state) => {
        return options.filter(option =>
          option.name.toLowerCase().includes(state.inputValue.toLowerCase())
        );
      }}
    />
  );
}

export default CitySelect;
